import CascadedSelectMixin from 'trunks/vue/share/components/fields/cascaded_select.js';
import CascadedSelect from 'trunks/vue/admin/components/cascaded_select.js';
import FieldMixinForResponse from './mixin.js';

const CascadedSelectForResponse = {
  mixins: [
    FieldMixinForResponse,
    CascadedSelectMixin
  ],

  components: {
    'cascaded-select': CascadedSelect
  },

  template: `
    <Field :field='field'
           v-show='visible'
           :extendClass='[fieldCommonClass, fieldDifferenceClass]'
           :message='errorMsg'>
      <template slot='input'>
        <template v-if='!editing'>
          <div class="form-field-value input-control readonly right-addon" v-if='value'>
            <input class='controlled-input'
                   type="text"
                   readonly
                   :value='fullName'
                   placeholder='请输入' />
            <div class="addon">
              <i class='slp-caret-down'></i>
            </div>
          </div>
          <div class="form-field-value placeholder" v-else>未填写</div>
        </template>
        <cascaded-select v-else
                         :resource='resource'
                         :defaultValue='defaultValue'
                         @valueChange='valueChange'
                         ref='cascadedSelect'></cascaded-select>
      </template>
    </Field>
  `
};

export default CascadedSelectForResponse;
